import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getConfigWithContext } from 'Config';

import { selectContext } from 'Store/context/selectors';

const IMAGE_WIDTH_HEIGHT = '512';

const ExperienceMeta = () => {
  const context = useSelector(selectContext);
  const { experience } = getConfigWithContext(context);

  const { formatMessage } = useIntl();

  if (!experience?.meta) {
    return null;
  }

  const { titleKey, descriptionKey, imageUrl } = experience.meta;

  const title = formatMessage({ id: titleKey });
  const description = formatMessage({ id: descriptionKey });

  const helmetProps = {
    title,
    meta: [
      { name: 'description', content: description },

      { property: 'og:description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:image', content: imageUrl },
      { property: 'og:image:width', content: IMAGE_WIDTH_HEIGHT },
      { property: 'og:image:height', content: IMAGE_WIDTH_HEIGHT },

      { name: 'twitter:title', content: title },
      { name: 'twitter:image', content: imageUrl },
      { name: 'twitter:description', content: description },
    ],
  };

  return <Helmet {...helmetProps} />;
};

export default ExperienceMeta;
